import { StepCardContent } from './StepCard'
import { useStepNavStore } from '../../stores/useStepNavStore'
import { getUseBotOnboardingStore } from '../../stores/useBotOnboardingStore'
import { Button, Input, useIsMobile } from '@bpinternal/ui-kit-next'
import { useEffect, useRef } from 'react'
import { generateRandomName } from '../../utils/generateBotName'

const MAX_NAME_LENGTH = 50

type Props = {
  workspaceId: string
  botId: string
}

export const BotNameStep = ({ workspaceId, botId }: Props) => {
  const isMobile = useIsMobile()

  const useBotOnboardingStore = getUseBotOnboardingStore({ botId, workspaceId })
  const name = useBotOnboardingStore((state) => state.name)
  const setName = useBotOnboardingStore((state) => state.setName)
  const setNextDisabled = useStepNavStore((state) => state.setNextDisabled)
  const setProgressBarStep = useStepNavStore((state) => state.setProgressBarStep)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setProgressBarStep(1)
    inputRef.current?.focus()
    setNextDisabled(false)
  }, [])

  return (
    <StepCardContent
      className="flex flex-1 flex-col justify-end gap-4 lg:flex-row lg:items-center"
      title="Setup"
      description="We’ll guide you through four quick steps. First, name your bot."
    >
      {isMobile && (
        <Button variant="secondary" className="h-10 w-fit self-end" onClick={() => setName(generateRandomName())}>
          Auto Generate
        </Button>
      )}
      <Input
        ref={inputRef}
        className="h-10"
        value={name}
        placeholder="What should we call your bot?"
        onChange={(e) => setName(e.target.value)}
        maxLength={MAX_NAME_LENGTH}
      ></Input>
      {!isMobile && (
        <Button variant="secondary" className="h-10 w-fit" onClick={() => setName(generateRandomName())}>
          Auto Generate
        </Button>
      )}
    </StepCardContent>
  )
}
